"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@veeam/core");
var rxjs_1 = require("rxjs");
function getSizeValue(value, rootValue) {
    if (Number.isInteger(value) || value > 1) {
        return value;
    }
    return rootValue * value;
}
var SplitLayoutInteractor = /** @class */ (function (_super) {
    __extends(SplitLayoutInteractor, _super);
    function SplitLayoutInteractor(configModelOrConfig) {
        var _this = _super.call(this) || this;
        _this.configModelOrConfig = configModelOrConfig;
        _this.sizeModel = new core_1.Model({
            shouldApply: false,
            width: 0,
            height: 0
        });
        _this.startX = 0;
        _this.startY = 0;
        _this.startBoxSize = {
            width: 0,
            height: 0
        };
        _this.rootBoxSize = {
            width: 0,
            height: 0
        };
        _this.sub = new rxjs_1.Subscription();
        _this.didResizeStart = function (x, y) {
            if (_this.presenter) {
                _this.rootBoxSize = _this.presenter.measureRootBox();
                _this.startBoxSize = _this.presenter.measureStartBox();
            }
            _this.startX = x;
            _this.startY = y;
        };
        _this.didResizeEnd = function () {
            var newValue = _this.sizeModel.getValue();
            var isRow = _this.startBoxSize.height === newValue.height;
            if (_this.onSizeChange) {
                _this.onSizeChange(isRow ? _this.startBoxSize.width : _this.startBoxSize.height, isRow ? newValue.width : newValue.height);
            }
        };
        _this.didMouseMove = function (x, y) {
            var diff = {
                x: x - _this.startX,
                y: y - _this.startY
            };
            _this.updateSize(diff);
        };
        if (configModelOrConfig instanceof core_1.Model) {
            _this.config = configModelOrConfig.getValue();
        }
        else {
            _this.config = configModelOrConfig;
        }
        return _this;
    }
    SplitLayoutInteractor.prototype.willActivate = function () {
        var _a;
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_b) {
                if (this.configModelOrConfig instanceof core_1.Model) {
                    this.sub.add((_a = this.configModelOrConfig) === null || _a === void 0 ? void 0 : _a.subscribe(function (config) {
                        _this.config = config;
                    }));
                }
                return [2 /*return*/];
            });
        });
    };
    SplitLayoutInteractor.prototype.willDeactivate = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                this.sub.unsubscribe();
                return [2 /*return*/];
            });
        });
    };
    SplitLayoutInteractor.prototype.updateSize = function (diff) {
        var _a = this.getLimitedSize(), minWidth = _a[0], maxWidth = _a[1];
        var _b = this.getLimitedSize(true), minHeight = _b[0], maxHeight = _b[1];
        this.sizeModel.setValue({
            shouldApply: true,
            width: Math.round(Math.min(maxWidth, Math.max(this.startBoxSize.width + diff.x, minWidth))),
            height: Math.round(Math.min(maxHeight, Math.max(this.startBoxSize.height + diff.y, minHeight)))
        });
    };
    SplitLayoutInteractor.prototype.getLimitedSize = function (isColumnDirection) {
        var _a, _b, _c, _d, _e, _f, _g, _h;
        var rootSize = isColumnDirection ? this.rootBoxSize.height : this.rootBoxSize.width;
        var minWidth = getSizeValue(((_b = (_a = this.config) === null || _a === void 0 ? void 0 : _a.startLimit) === null || _b === void 0 ? void 0 : _b.minSize) || 1, rootSize);
        if ((_d = (_c = this.config) === null || _c === void 0 ? void 0 : _c.endLimit) === null || _d === void 0 ? void 0 : _d.maxSize) {
            minWidth = Math.max(rootSize - getSizeValue(this.config.endLimit.maxSize, rootSize), minWidth);
        }
        var maxWidth = Math.min(getSizeValue(((_f = (_e = this.config) === null || _e === void 0 ? void 0 : _e.startLimit) === null || _f === void 0 ? void 0 : _f.maxSize) || rootSize, rootSize), rootSize);
        if ((_h = (_g = this.config) === null || _g === void 0 ? void 0 : _g.endLimit) === null || _h === void 0 ? void 0 : _h.minSize) {
            maxWidth = Math.min(Math.max(rootSize - getSizeValue(this.config.endLimit.minSize, rootSize), 1), maxWidth);
        }
        return [minWidth, maxWidth];
    };
    return SplitLayoutInteractor;
}(core_1.Interactor));
exports.SplitLayoutInteractor = SplitLayoutInteractor;
//# sourceMappingURL=SplitLayoutInteractor.js.map